import { Tag, TagMap } from '../../../../../../common/tags/tagTypes';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectTags, selectTagPaths } from '../../../../../element/tags/tagSelectors';
import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';
import { getElementId } from '../../../../../../common/elements/utils/elementPropertyUtils';

export type UseTagPopupsStateReturn = {
    allTags: Tag[];
    currentBoardTags: Tag[];
    currentlyEditingTag: Tag | null;
    setCurrentlyEditingTagId: (tagId: string | null) => void;
    userRootPath: ImMNElement[];
    shareRootPath: ImMNElement[];
    handleClickEdit: (tag: Tag) => void;
};

const useTagPopupsState = (openModal: () => void): UseTagPopupsStateReturn => {
    const [currentlyEditingTagId, setCurrentlyEditingTagId] = useState<string | null>(null);
    const rootPaths = useSelector(selectTagPaths);
    const { userRootPath, shareRootPath } = rootPaths || {};

    const tags: TagMap | undefined = useSelector(selectTags);
    const currentlyEditingTag = tags?.[currentlyEditingTagId || ''] || null;

    const allTags = Object.values(tags || {});
    const currentBoardTags = allTags.filter((tag) =>
        userRootPath.some((board: ImMNElement) => tag.rootBoardIds?.includes(getElementId(board))),
    );

    const handleClickEdit = (tag: Tag) => {
        setCurrentlyEditingTagId(tag.id);
        openModal();
    };

    return {
        allTags,
        currentBoardTags,
        currentlyEditingTag,
        setCurrentlyEditingTagId,
        userRootPath,
        shareRootPath,
        handleClickEdit,
    };
};

export default useTagPopupsState;
